module.exports = __webpack_public_path__ + "static/media/signage-industrial-img18.2d97fbf5.jpg";